import { config } from "@/lib/config";
import { Link } from "react-router-dom";

export default function ChiMain() {
  return (
    <div className="m-0 mb-20 mt-20 flex w-full justify-center p-0">
      <div>
        <Link to={`${config.basePath}/csi-festes/`}>
          <img
            src={`${config.basePath}/images/csi/csifestes-tengely.jpg`}
            alt="Csí-festés"
            className="mx-auto w-[55%] border-2 border-blue-700 brightness-100 drop-shadow-2xl hover:scale-110 hover:brightness-110"
          />
        </Link>
      </div>
    </div>
  );
}
